const skipTo = () => {
  const $skipTo = $('.skip-to');
  const $skipToBtn = $skipTo.find('.skip-to__button');
  const toggleContent = () => {
    $skipTo.toggleClass('is-showing');
  }
  $skipToBtn.on('click', toggleContent);
}

export default skipTo;


// WEBPACK FOOTER //
// ./scripts/components/skip-to.js